<template>
  <div class="form-item-input" style="align-items: center">
    <el-input-number style="flex: 1" v-bind="$attrs" v-on="$listeners" />
    <span>KGS</span>
  </div>
</template>

<script>
export default {
  name: 'SeCargoDocWeight'
}
</script>

<style lang="scss" scoped>
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
</style>
